import * as React from "react";
import { FavoritesIcon } from "../FavoritesIcon";
import { MarketsCount } from "../MarketsCount";
export const MarketsCountLink = (props) => {
    return (React.createElement("a", { href: props.details.event.linkUrl, onClick: props.details.handlers.eventCard, className: `rj-ev-list__${props.componentPrefix}__section rj-ev-list__${props.componentPrefix}__section--counter`, "data-uat": `a-ev-list-${props.componentPrefix}-section-counter` },
        props.details.isFavoritesEnabled &&
            React.createElement(FavoritesIcon, { isInFavorites: props.details.event.isInFavorites, favoritesHandler: props.details.handlers.favorites }),
        React.createElement(MarketsCount, { count: props.details.event.marketLinesCount, componentPrefix: props.componentPrefix })));
};
//# sourceMappingURL=MarketsCountLink.js.map